import React from "react";

export interface VGetAccessProps {
  title: string;
  GetAccessData: any;
}

const GetAccess: React.FC<VGetAccessProps> = (props) => {
  return (
    <div className="getAccess ">
      <div className="container">
        <div>
          <h2>{props.title}</h2>
          <div className="includes_section">
            {props.GetAccessData.map((getAcc: any, i: number) => {
              return (
                <div key={i} className="display-flex">
                  <div className="listWrap">
                    <div className="circle-blue">
                      <i className="edel-icon-right-arrow"></i>
                    </div>
                    <div className="text home_text">
                      <p>{getAcc.heading} </p>
                      {getAcc.sub_heading ? <p>{getAcc.sub_heading}</p> : null}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="footerInfo">
            <p>*Offer valid for limited time</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetAccess;
